import HousekeepingReqsData from "../../components/hotel/datamanagement/HousekeepingData";

export default function HousekeepingPage() {
  return <HousekeepingReqsData />;
}

